<template>
  <Modal :closable="false" v-if="show">
    <v-container class="pa-3">
      <v-layout align-content-space-around>
        <v-flex class="title-container ml-4 mb-4">
          <h3 class="modal-title">CARD TYPE MISMATCH</h3>
        </v-flex>
        <v-btn
color="#A1A0A0"
small
flat
icon
@click="$emit('close')">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-layout>
      <v-layout class="px-4 mb-2">
        <p class="modal-description">
          {{modalText}}
        </p>
      </v-layout>
      <v-layout column wrap class="px-4 mb-4">
        <v-flex
v-for="(invoice) in invoices"
:key="`invoice_${invoice.id}`"
          class="invoice-unit">
          <span>Invoice #{{invoice.id}}</span>
          <span>{{currency( invoice.amountDue )}}</span>
        </v-flex>
        <v-flex class="invoice-unit" v-if="cardType === 'DEBIT_CARD'">
          <span>Credit Card Surcharge</span>
          <span>{{ currency( CCsurcharge.amount ) }}</span>
        </v-flex>
        <v-flex class="invoice-total">
          <span>Total Amount Due</span>
          <span>{{currency( paymentAmount )}}</span>
        </v-flex>
      </v-layout>
      <v-layout column class="px-3">
        <v-btn color="#F7942F" class="modal-btn" @click="cardTypeChange">
          <v-icon color="white" class="mr-2">lock</v-icon>
          <span>Make Secure Payment</span>
        </v-btn>
        <v-btn class="modal-btn" @click="$emit('close')">
          Enter a Different Card
        </v-btn>
      </v-layout>
    </v-container>
  </Modal>
</template>

<script>
import { Mixins } from '@spectorasoftware/homegauge-vue';
import Modal from '@/components/Shared/Modal.vue';

const { CurrencyFilter } = Mixins;

export default {
  components: {
    Modal,
  },
  mixins: [CurrencyFilter],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    invoices: {
      type: Array,
      default: () => [],
    },
    paymentAmount: {
      type: Number,
      default: 0,
    },
    creditCardSurcharge: {
      type: Number,
      required: true,
    },
    cardType: {
      type: String,
      required: false,
    },
  },
  methods: {
    cardTypeChange() {
      if (this.cardType === 'CREDIT_CARD') {
        this.$emit('changeCardType', 'DEBIT_CARD');
      }
      this.$emit('changeCardType', 'CREDIT_CARD');
      this.$emit('close');
    },
  },
  computed: {
    CCsurcharge() {
      return {
        value: this.creditCardSurcharge / 100,
        amount: (this.paymentAmount * this.creditCardSurcharge) / 10000,
      };
    },
    modalText() {
      return this.cardType === 'CREDIT_CARD'
        ? `You selected the credit card payment type,
       but the card you entered is a debit card. Using a debit card will remove the ${this.currency(this.CCsurcharge.amount)} surcharge.`
        : `You selected the debit card payment type,
       but the card you entered is a credit card. There is a ${this.currency(this.CCsurcharge.amount)} surcharge to use a credit card.`;
    },
  },
};
</script>

<style lang="scss" scoped>
.title-container{
  text-align: center;
}
.modal-title {
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.06em;
  line-height: 28px;
  color: #2d2d2d;
  font-style: normal;
}
.modal-description {
  font-size: 14px;
  line-height: 20px;
  color: #4E4B4D;
}
.invoice-unit {
  border-top: 1px solid #D9D9D1;
  color: #797979;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  justify-content: space-between;
  padding: 0px!important;
}
.invoice-total{
  border-top: 1px solid #000000;
  color: #000000;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  justify-content: space-between;
  padding: 0px!important;
}
.modal-btn{
  font-weight: 700;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.12em;
  color: #2D2D2D;
}
</style>
